import '../CSS/Estilo.css';
import {fetchRequest,SHA256} from "./RequestUtils";
import {useEffect} from "react";

export default function FormularioDatosUsuario({datos,sendToHome,config,rotulo,mostrarBotonCancel,btCancelarEdicionClicked})
{
  ///////////////////////////////
  //
  //  BORRAR EL CONTENIDO DE LAS CAJAS DE TEXTO SI SE
  //  MUESTRA EL FORMULARIO PARA AÑADIR UN NUEVO USUARIO
  //  ( la propiedad datos es undefined )
  //
  ///////////////////////////////////////////////
  //
  useEffect(()=>{
    if(!datos) {
      document.getElementById('nom').value='';
      document.getElementById('apellidos').value='';
      document.getElementById('nombreusu').value='';
      document.getElementById('email').value='';
      document.getElementById('dir').value='';
      document.getElementById('cp').value='';
      document.getElementById('tel').value='';
      document.getElementById('pwd').value='';
      document.getElementById('nom').focus();
    }
  });

  //////////////////////////
  //
  //  MANEJADOR DEL EVENTO DE PULSAR LA TECLA INTRO EN LAS CAJAS DE TEXTO
  //
  ////////////////////////////////////
  //
  function tbEnter(ev){
    if (ev.key === "Enter") {
      switch (ev.target.id) {
        /*Formulario de nuevo usuario */
        case 'nom':
          document.getElementById("apellidos").focus();
          break;
        case 'apellidos':
          (datos)?
              document.getElementById("nuevoUid").focus():
              document.getElementById("nombreusu").focus();
          break;
        case 'nombreusu':
          (datos)?
            document.getElementById("nuevoUid").focus():
            document.getElementById("email").focus();
          break;
        case 'nuevoUid':
          document.getElementById("email").focus();
          break;
        case 'email':
          document.getElementById("dir").focus();
          break;
        case 'dir':
          document.getElementById("cp").focus();
          break;
        case 'cp':
          document.getElementById("tel").focus();
          break;
        case 'tel':
          document.getElementById("pwd").focus();
          break;
        case 'pwd':
            document.getElementById("nom").focus();
          break;
        default:
          break;
      }
    }
  }

  //////////////////////
  //
  // COMPRUEBA LOS DATOS INTRODUCIDOS EN EL FORMULARIO Y 
  // EN CASO DE SER CORRECTOS LOS ENVIA
  //
  /////////////////////////////////
  //
  function enviarDatosUsuario(){
    //Obtener los datos introducidos
    let nom = document.getElementById("nom").value;
    let apellidos = document.getElementById("apellidos").value;
    let nomusu = document.getElementById("nombreusu").value;
    let newUid;
    newUid = (datos)? document.getElementById("nuevoUid").value:'';
    let email = document.getElementById("email").value;
    let dir = document.getElementById("dir").value;
    let tbCp = document.getElementById("cp");
    let cp = tbCp.value;
    let tbTel = document.getElementById("tel");
    let tel = tbTel.value;
    let tbPwd = document.getElementById("pwd");
    let pwd='';
    if(tbPwd.value.trim().length > 0)
      pwd= SHA256(tbPwd.value);
    //Token del ususario administrador que añade un nuevo usuario o del usuario que modifica sus datos
    let token = sessionStorage.getItem('token');
    //Comprobar los datos
    let dades = { nom: nom, apellidos: apellidos, nomusu: nomusu, email: email, dir: dir, cp: cp, tel: tel, pwd: tbPwd.value };
    if (nom.length === 0 || apellidos.length === 0 || nomusu.length === 0 || email.length === 0 || dir.length === 0 ||
        cp.length === 0 || tel.length === 0 || (!datos && pwd.length === 0)) {
      alert("No pueden haber campos vacíos."+(datos.uid)?'Excepto el nuevo nombre de usuario y nuevo password':'');
      return;
    }
    let correcte = comprobarDatos(dades);
    if (correcte !== "OK") {
      alert(correcte);
      return;
    }
    //Enviar la petición en funcion de si es para un nuevo usuario
    // o para modificar los datos de uno existente ( la propiedad datos esta definida )
    if(datos)//Enviar datos para modificar los existentes en el servidor
    {
      //alert("Envio de datos para modificar.");
      const callback = (response)=>{
        if(response) {
          if (response.data.changeUserData) {
            alert("Datos del usuario cambiados con éxito en el servidor remoto"+(sendToHome?".\nSerá rederigido a la página home.":"."));
            if(sendToHome)
              window.location='/';
            else
              window.location.reload();
          }
          else
            alert("Error.No se han cambiado los datos del usuario en el servidor remoto.");
        }
        else
        {
          alert("Error. No se ha recibido respuesta del servidor remoto.");
        }
      }
      fetchRequest('changeUserData',
          [{nombre: 'nom', valor: nom}, {nombre: 'cognom', valor: apellidos},
            {nombre: 'nomusu', valor: nomusu},{nombre: 'newUid', valor: newUid}, {nombre: 'email', valor: email}, {nombre: 'dir', valor: dir},
            {nombre: 'cp', valor: cp}, {nombre: 'tel', valor: tel}, {nombre: 'pwd', valor: pwd},{nombre:'token',valor:token}],
          'POST', config.ip, config.port, config.protocolo, 'json', callback)
    }
    else {//Enviar los datos para incluirlos en el servidor
      const callback = (response) => {
        if (response) {
          //alert("Resposta: " + response.data.addUsuarioLdap);
          if (response && response.data.addNewUser) {
            alert("Nuevo usuario añadido correctamente.");
            window.location.reload();
          } else
            alert("Error: Compruebe que el usuario o el password no existen ya y vuelva a intentarlo por favor.");
        } else
          alert("Error, no se ha recibido respuesta del servidor");
      }
      fetchRequest('addNewUser',
          [{nombre: 'token', valor: token}, {nombre: 'nom', valor: nom}, {nombre: 'cognom', valor: apellidos},
            {nombre: 'nomusu', valor: nomusu}, {nombre: 'email', valor: email}, {nombre: 'dir', valor: dir},
            {nombre: 'cp', valor: cp}, {nombre: 'tel', valor: tel}, {nombre: 'pwd', valor: pwd}],
          'POST', config.ip, config.port, config.protocolo, 'json', callback)
    }
  }


  ///////////////////////////
  //
  // RETORNA EL NOMBRE DEL DATO ERRONEO O OK SI TODOS LOS
  // DATOS SON CORRECTOS
  //
  /////////////////////////////////////////
  //
  function comprobarDatos(datos) {
    if (datos.nom)//Comprobar que no hi hagin nombres
    {
      let nom = datos.nom;
      for (let i = 0; i < nom.length; i++)
        if (!isNaN(nom.charAt(i)) && nom.charAt(i) !== ' ')
          return "Nombre erroneo. El nombre no puede contener números." + nom.charAt(i);
    }
    if (datos.apellidos)//Comprobar que no hi hagin nombres
    {
      let apellidos = datos.apellidos;
      for (let i = 0; i < apellidos.length; i++)
        if (!isNaN(apellidos.charAt(i)) && apellidos.charAt(i) !== ' ')
          return "Apellidos erroneos. Los apellidos no pueden contener números.";
    }
    if (datos.email) {
      let email = datos.email;
      if (!email.includes("@") || !email.includes("."))
        return "Email erroneo.";
    }
    if (datos.cp) {
      let cp = datos.cp;
      if ((!Number.isInteger(cp * 1)) || cp.length < 5)
        return "Codigo postal erroneo";
    }
    if (datos.tel) {
      let tel = datos.tel;
      if ((!Number.isInteger(tel * 1)) || tel.length < 9)
        return "Teléfono erroneo.";
    }
    if (datos.pwd) {
      let pwd = datos.pwd;
      if (!datos && pwd.length < 8)
        return "La contraseña ha de tener al menos 8 caracteres.";
    }
    return "OK";
  }



    return (
        <div>
          <label id={"lbRotulo"} style={{color:config.estiloPagina.color,width:'100%',display:'block',textAlign:'center',
            marginBottom:'2%'}} className='rotuloMediano'>{rotulo}</label>
          <div id={"interno"} onKeyDown={tbEnter}>
            <div className='interno'>
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Nombre</label>
              <input className={"tbForm"} autoFocus type="text" id="nom" name="nombre"
                  defaultValue={(datos)?datos.cn:null}/>
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Apellidos</label>
              <input className={"tbForm"} type="text" id="apellidos" name="apellidos"
                     defaultValue={(datos)?datos.sn:null} />
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Nombre de usuario</label>
              <input className={"tbForm"} type="text" id="nombreusu" name="nombreusu"
                     defaultValue={(datos)?datos.uid:null} disabled={datos}/>
              {datos && <div>
                <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Nuevo nombre de usuario</label>
                <input className={"tbForm"} type="text" id="nuevoUid" name="nuevoUid"
                       defaultValue={(datos)?'':null} />
              </div>}
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Email</label>
              <input className={"tbForm"} type="email" id="email" name="email"
                     defaultValue={(datos)?datos.mail:null} />
            </div>
            <div  className='interno' onKeyDown={tbEnter}>
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Dirección</label>
              <input className={"tbForm"} type="text" id="dir" name="direccion"
                     defaultValue={(datos)?datos.postalAddress:null} />
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Codigo postal</label>
              <input className={"tbForm"} type="text" id="cp" name="codigopostal"
                     defaultValue={(datos)?datos.postalCode:null} />
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>Teléfono</label>
              <input className={"tbForm"} type="text" id="tel" name="telefono"
                     defaultValue={(datos)?datos.telephoneNumber:null} />
              <label style={{color:config.estiloPagina.color}} className={"lbForm"}>{datos?'Nuevo Password':'Password'}</label>
              <input className={"tbForm"} id="pwd" name="pwd" type="password" />
            </div>
          </div>
          <div id={'divBotonesEdicion'}>
            <button style={{marginLeft:'44%'}}className='btEnvio'
                    onClick={enviarDatosUsuario} >Enviar</button>
            { mostrarBotonCancel && <button className='btCancelar' onClick={btCancelarEdicionClicked}>Cancelar</button> }
          </div>
        </div>
      )
}